import React from "react";
import HeroSearch from "../HeroSearch";

const Hero = () => {
    return (
        <section className="hero_single version_1">
            <div className="wrapper">
                <div className="container">
                    <h3>Every Review is an Experience!</h3>
                    <p>Check Ratings of Businesses, Read Reviews &amp; Buy</p>
                    <HeroSearch />
                </div>
            </div>
        </section>
    )
}

export default Hero